<template>
  <tk-container
    class=""
  >
    <!-- 固定部分 -->
    <div
      slot="header"
      class="flex items-center mb-10 px-15 pt-15"
    >
      <!-- 返回 -->
      <global-back class="mr-10" />
      <van-field
        v-model="word"
        label=""
        clearable
        clear-trigger="always"
        class="rounded-10"
        @clear="handlerClear"
        style="padding-top: 8px !important;
          padding-bottom: 8px !important;"
        placeholder="请输入您想要搜索的内容"
      >
        <template #button>
          <div
            :class="{ 'text-black': word.length > 0 }"
            class="cursor-pointer text-12 font-600"
            @click="handlerSearch"
          >
            搜索
          </div>
        </template>
      </van-field>
    </div>
    <div class="p-x-15 pb-15">
      <div class="h-8"></div>
      <div class="w-full">
        <!-- 滚动部分 -->
        <div>
          <van-row
            v-if="list.length > 0"
            :gutter="10"
          >
            <van-col
              v-for="(item, index) in list"
              :key="index"
              span="12"
            >
              <course-card :data="item" />
            </van-col>
          </van-row>
          <div v-else>
            <global-empty
              v-if="isShowEmpty"
              word="没有找到相关内容～"
            />
          </div>
        </div>
      </div>
    </div>
  </tk-container>
</template>

<script>
import { Toast } from 'vant'
export default {
  data () {
    return {
      word: '',
      list: [],
      isShowEmpty: false,
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    handlerClear () {
      this.word = ''
      this.list = []
      this.isShowEmpty = false
    },
    async handlerSearch () {
      if (!this.word) {
        return
      }
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '查询中...',
      })
      const result = await this.$tkParse.getList('/classes/courseList', {
        params: {
          limit: 3000,
          where: {
            title: {
              $regex: `(?i)${this.word}`,
            },
          },
        },
      }).catch(() => {
        Toast.clear()
        return Toast({
          message: '查询失败',
          position: 'bottom',
        })
      })
      this.list = result
      this.isShowEmpty = true
      Toast.clear()
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .van-icon-clear {
    color: #9C9C9C !important;
    font-size: 13px;
  }
}
</style>
